var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.7104 0 0 4.7104 0 10.5C0 16.2896 4.7104 21 10.5 21C16.2896 21 21 16.2896 21 10.5C21 4.7104 16.2896 0 10.5 0ZM10.5 19.6875C5.43392 19.6875 1.31251 15.5661 1.31251 10.5C1.31251 5.43392 5.43392 1.31251 10.5 1.31251C15.5661 1.31251 19.6875 5.43392 19.6875 10.5C19.6875 15.5661 15.5661 19.6875 10.5 19.6875Z",
    fill: "#4F4A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0724 4.2002H9.80078V10.7452L13.8017 14.7002L14.7008 13.8115L11.0724 10.2247V4.2002Z",
    fill: "#4F4A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentTypeIcon);
export default __webpack_public_path__ + "static/media/employment-type-icon.f8454fe588aadaabc64fcb7bccc04ca9.svg";
export { ForwardRef as ReactComponent };